import React from "react";
import { CardGlobal } from "../../Context/Context";

const Collection = () => {
  const { topCollection } = CardGlobal();
  return (
    <div className="collection-section section-padding">
      <div className="container">
        <div className="row ">
          <div className="col-lg-6 collection-title text-center mx-auto gap-4">
            <h2 className="text-white" data-aos='fade-up' >Top Collection Over</h2>
          </div>
        </div>

        <div className="row  g-md-4 g-3 mt-5">
          {topCollection.map((element , index) => {
            return (
              <div key={index}    className="col-lg-3 col-6 " data-aos='fade-up' >
                <div className="collection-card d-flex align-items-center gap-sm-4 gap-3 p-sm-4 p-3 rounded-4 shadow">
                  <div className="collection-img position-relative">
                    <img src={element.img} alt="" />
                    <span>{element.count}</span>
                  </div>
                  <div className="collection-content">
                    <h4 className="text-white">{element.title}</h4>
                    <p className="mb-0">{element.content}</p>
                  </div>
                </div>
              </div>
            )
          })}

            <div className="collection-btn mt-md-5 mt-4 d-flex align-items-center justify-content-center" data-aos='zoom-in'>
          <button className="btn btn-primary">Go to ranking</button>

            </div>

        </div>

      </div>
    </div>
  );
};

export default Collection;
